import Breadcrumb from "../Component/Breadcrumb";
const StaffPhotos = () => {
  return (
    <>
      <Breadcrumb
        breadtitle="Staff Photos"
        breadmid="Facilities"
        breadend="Staff Photos"
      />
      <div className="innerpage library_blk">
        <div className="container">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-12">
              <div class="img-box staff">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/staff1.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/staff1.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12">
              <div class="img-box staff">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/staff2.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/staff2.jpg"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StaffPhotos;
